import React, { useCallback } from 'react';
import {
  useSnackbar, OptionsObject, SnackbarMessage, SnackbarKey,
} from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

/**
 * 予約フォーム向けスナックバーフック。
 * - variant: 'error' の通知は persist を有効化し、ユーザーが × で閉じるまで表示し続ける
 *   （入力エラー等、解消されるまで内容を確認できるようにするため）
 * - persist を付ける通知には閉じるための × ボタンを自動で付与する
 * - 他 variant（success/info/warning）は notistack のデフォルト挙動（自動クローズ）のまま
 *
 * 呼び出し側は従来の useSnackbar と同じ API で利用可能。
 * 個別に persist や action を上書きしたい場合は options に明示すれば優先される。
 */
const useAppSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const enqueue = useCallback(
    (message: SnackbarMessage, options?: OptionsObject): SnackbarKey => {
      const isError = options?.variant === 'error';
      const persist = options?.persist ?? isError;
      const action = options?.action ?? (persist
        ? (key: SnackbarKey) => (
          <IconButton
            size="small"
            aria-label="close"
            style={{ color: '#fff' }}
            onClick={() => closeSnackbar(key)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )
        : undefined);

      return enqueueSnackbar(message, {
        ...options,
        persist,
        action,
      });
    },
    [enqueueSnackbar, closeSnackbar],
  );

  return { enqueueSnackbar: enqueue, closeSnackbar };
};

export default useAppSnackbar;
